export default {
  en: {
    newContract: 'New Contract',
    hotel: 'Hotel',
    cancel: 'Cancel',
    create: 'Create',
    createContractSuccessTitle: 'Success',
    createContractSuccessMessage: 'Create Contract Success.'
  },
  th: {
    newContract: 'สร้างสัญญา',
    hotel: 'โรงแรม',
    cancel: 'ยกเลิก',
    create: 'สร้าง',
    createContractSuccessTitle: 'สำเร็จ',
    createContractSuccessMessage: 'สร้างสัญญาใหม่สำเร็จ'
  }
}
